import { createAction } from '@reduxjs/toolkit'
import { IdProductsStateDataItem, typeProductsFilters } from './dProductsReducer'
import { typeEditProductsItemObject } from 'components/containers/dashboard/dataProducts/popupContents/popupEdit'
import { typeAddProductsItemObject } from 'components/containers/dashboard/dataProducts/popupContents/popupAdd'
import {
    typeBulkChangeCategoryObject
} from 'components/containers/dashboard/dataProducts/popupContents/popupBulkChangeCategory'
import { typePagination, typeRequestPagination } from '../system/constants'


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dProductsSetDataAC = createAction(
    'D_PRODUCTS_SET_DATA',
    (
        dataList: IdProductsStateDataItem[],
    ) => ( { payload: { dataList } } )
)

// Action creator of set pagination
export const dProductsSetPaginationAC = createAction(
    'D_PRODUCTS_SET_PAGINATION',
    (
        pagination: typePagination,
    ) => ( { payload: { pagination } } )
)
// Action creator of set itemsForPage in pagination
export const dProductsSetItemsForPageAC = createAction(
    'D_PRODUCTS_SET_ITEMS_FOR_PAGE',
    (
        itemsForPage: number,
    ) => ( { payload: { itemsForPage } } )
)


// Action creator of set pageNumber in pagination
export const dProductsSetPageNumberAC = createAction(
    'D_PRODUCTS_SET_PAGE_NUMBER',
    (
        pageNumber: number,
    ) => ( { payload: { pageNumber } } )
)


// Action creator of saga set data
export const dProductsSetDataSagaAC = createAction(
    'D_PRODUCTS_SET_DATA_SAGA',
    (
        filters: typeProductsFilters,
        paginationRequest: typeRequestPagination
    ) => ( { payload: { filters, paginationRequest } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dProductsSetDetailItemAC = createAction(
    'D_PRODUCTS_SET_DETAIL_ITEM',
    (detailItemId: string) => ( { payload: detailItemId } )
)

export const dProductsClearDetailItemAC = createAction(
    'D_PRODUCTS_Clear_DETAIL_ITEM',
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga edit item
export const dProductsEditItemSagaAC = createAction(
    'D_PRODUCTS_CHANGE_ITEM_SAGA',
    (itemObject: typeEditProductsItemObject, filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
      payload: {
          itemObject,
          filters,
          paginationRequest
      },
    })
);

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga add item
export const dProductsAddItemSagaAC = createAction(
    'D_PRODUCTS_ADD_ITEM_SAGA',
    ( itemObject: typeAddProductsItemObject, filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            itemObject,
            filters,
            paginationRequest
        }
    } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga delete item
export const dProductsDeleteItemSagaAC = createAction(
    'D_PRODUCTS_DELETE_ITEM_SAGA',
    ( itemId: string, filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            itemId,
            filters,
            paginationRequest
        }
    } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga recover item
export const dProductsRecoverItemSagaAC = createAction(
    'D_PRODUCTS_RECOVER_ITEM_SAGA',
    ( itemId: string, filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            itemId,
            filters,
            paginationRequest
        }
    } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dProductsClearFiltersAC = createAction(
    'D_PRODUCTS_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dProductsSetFiltersAC = createAction(
    'D_PRODUCTS_SET_FILTERS',
    (filtersObject: typeProductsFilters) => ( { payload: filtersObject } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set checked item
export const dProductsCheckedItemAC = createAction(
    'D_PRODUCTS_CHECK_ITEM',
    (itemId: string) => ( { payload: itemId } )
)

// Action creator of checked all items
export const dProductsCheckedAllItemAC = createAction(
    'D_PRODUCTS_CHECK_ALL_ITEM',
    (value: boolean) => ( { payload: value } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of bulk patch saga
export const dProductsBulkPatchSagaAC = createAction(
    'D_PRODUCTS_BULK_PATCH_SAGA',
    ( bulkObjectList: typeBulkChangeCategoryObject[], filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            bulkObjectList,
            filters,
            paginationRequest
        }
    } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of bulk recovery saga
export const dProductsBulkRecoverySagaAC = createAction(
    'D_PRODUCTS_BULK_RECOVERY_SAGA',
    ( bulkIdList: string[], filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            bulkIdList,
            filters,
            paginationRequest
        }
    } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of bulk delete saga
export const dProductsBulkDeleteSagaAC = createAction(
    'D_PRODUCTS_BULK_DELETE_SAGA',
    ( bulkIdList: string[], filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            bulkIdList,
            filters,
            paginationRequest
        }
    } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of bulk off-sale saga
export const dProductsBulkOffSaleSagaAC = createAction(
    'D_PRODUCTS_BULK_OFF_SALE_SAGA',
    ( productIds: string[], storeIds: string[], filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            productIds,
            storeIds,
            filters,
            paginationRequest
        }
    } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of bulk delete from stores saga
export const dProductsBulkDeleteFromStoresSagaAC = createAction(
    'D_PRODUCTS_BULK_DELETE_FROM_STORES_SAGA',
    ( productIds: string[], storeIds: string[], filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            productIds,
            storeIds,
            filters,
            paginationRequest
        }
    } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of export data
export const dProductsExportDataSagaAC = createAction(
    'D_PRODUCTS_EXPORT_DATA_SAGA',
    (productIds: string[], storeIds: string[], lang: string) => ( {
        payload: {
            productIds, storeIds, lang
        }
    } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of import data
export const dProductsImportDataSagaAC = createAction(
    'D_PRODUCTS_IMPORT_DATA_SAGA',
    ( formData: FormData, filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            formData,
            filters,
            paginationRequest
        }
    } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of export data
export const dProductsSaveTemplateSagaAC = createAction(
    'D_PRODUCTS_SAVE_TEMPLATE_SAGA',

)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of  delete all saga
export const dProductsDeleteAllSagaAC = createAction(
    'D_PRODUCTS_DELETE_ALL_SAGA',
    ( filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            filters,
            paginationRequest
        }
    } )
)

export const dProductsDeleteAllFromStoreSagaAC = createAction(
    'D_PRODUCTS_DELETE_ALL_FROM_STORE_SAGA',
    (storeId: string | number, filters: typeProductsFilters, paginationRequest: typeRequestPagination) => ( {
        payload: {
            filters,
            paginationRequest,
            storeId,
        }
    } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of change vat saga
export const dProductsChangeVATSagaAC = createAction(
    'D_PRODUCTS_CHANGE_VAT_SAGA',
    ( filters: typeProductsFilters, paginationRequest: typeRequestPagination, vat: number) => ( {
        payload: {
            filters,
            paginationRequest,
            vat,
        }
    } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga restore deleted product with new data item
export const dProductsRestoreDeletedItemWithNewDataSagaAC = createAction(
    'D_PRODUCTS_RESTORE_DELETED_ITEM_WITH_NEW_DATA_SAGA',
    (
        itemObject: typeEditProductsItemObject,
        filters: typeProductsFilters,
        paginationRequest: typeRequestPagination
    ) => ( {
        payload: {
            itemObject,
            filters,
            paginationRequest
        }
    } )
)
